export class ServicePartnerSettings {
	PartnerId!: string;
	PartnerName!: string;
	ServicePartnerId!: string;
	ServicePartnerEnabled!: boolean;
	ServicePartnerName!: string;
	ServicePartnerContactName!: string;
	ServicePartnerContactEmail!: string;
}
